export default function FeatureGrid() {
  return (
    <section className="py-20 md:py-28 px-6 md:px-10 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="mb-14">
          <div className="flex items-center gap-3 mb-3">
            <span className="text-xs font-semibold uppercase tracking-widest text-foreground-500">
              CSSBuy / Sheet
            </span>
          </div>
          <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-foreground-950 leading-tight">
            Why Choose
            <br />
            <span className="italic font-semibold">CSSBuy Spreadsheet</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          <div className="bg-foreground-950 rounded-2xl p-8 md:p-10 flex flex-col justify-between min-h-[320px]">
            <div>
              <span className="inline-flex items-center justify-center w-10 h-10 rounded-full bg-white/10 text-white text-sm font-bold mb-6">
                1
              </span>
              <h3 className="font-heading text-3xl md:text-4xl font-bold text-white mb-3">
                Fast Access
              </h3>
              <p className="text-white/60 text-sm leading-relaxed">
                Instant links to all categories with one click. No more digging through forums
                or outdated spreadsheets &mdash; everything is organized and ready to browse.
              </p>
            </div>
          </div>

          <div className="relative rounded-2xl overflow-hidden min-h-[320px] group">
            <img
              src="https://readdy.ai/api/search-image?query=Professional%20clean%20product%20photography%20of%20trending%20fashion%20items%20sneakers%20clothing%20and%20accessories%20beautifully%20styled%20on%20a%20warm%20neutral%20cream%20background%20soft%20natural%20lighting%20editorial%20ecommerce%20style%20with%20muted%20earthy%20tones%20sage%20olive%20and%20beige%20color%20palette%20high%20end%20fashion%20catalog%20aesthetic&width=600&height=800&seq=feature-popular-2026&orientation=portrait"
              alt="Popular CSSBuy Spreadsheet finds"
              title="Top CSSBuy Spreadsheet Finds 2026"
              className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-black/10 to-transparent" />
            <div className="absolute top-6 left-6">
              <span className="inline-block px-3 py-1 rounded-full bg-accent-500 text-white text-xs font-medium">
                Popular
              </span>
            </div>
            <div className="absolute bottom-6 left-6">
              <h3 className="font-heading text-3xl md:text-4xl font-bold text-white">
                Top Finds
              </h3>
            </div>
          </div>

          <div className="bg-background-200/70 rounded-2xl p-8 md:p-10 flex flex-col justify-between min-h-[320px]">
            <div>
              <h3 className="font-heading text-4xl md:text-5xl font-bold text-foreground-950 mb-3">
                Updated Daily
              </h3>
              <p className="text-foreground-600 text-sm leading-relaxed mb-6">
                Fresh products added every day. Broken links are removed and new finds are
                added regularly, so your spreadsheet stays accurate and reliable.
              </p>
            </div>
            <div className="relative rounded-xl overflow-hidden aspect-[16/9]">
              <img
                src="https://readdy.ai/api/search-image?query=Minimalist%20aesthetic%20product%20photography%20of%20diverse%20fashion%20items%20laid%20out%20neatly%20on%20a%20warm%20cream%20surface%20soft%20natural%20morning%20light%20casting%20gentle%20shadows%20editorial%20ecommerce%20style%20with%20muted%20earthy%20tones%20sage%20olive%20beige%20and%20taupe%20color%20palette%20high%20end%20organized%20layout&width=600&height=338&seq=feature-daily-2026&orientation=landscape"
                alt="Daily updated CSSBuy spreadsheet products"
                title="CSSBuy Spreadsheet Daily Updates"
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}